export default __webpack_public_path__ + "static/image-one-mobile-c5243fc2ab28d9e02e0d5abfd9990f78.jpg";